import actions from "./actions";

const initState = {
    addonWiseMappingList: [],
    addonWiseMappingLoading: false,
    addonWiseMappingError: null,
    addonWiseMappingMessage: null,
    loading: false,
    buttonLoading: false,
    addonPriceMappingError: null,
    addonPriceMappingSuccess: null,
    addonPriceMappingData: [],

    openAddonModal: false,

    updateAddonWiseMappingLoading: false,
    updateAddonWiseMappingError: null,
    updateAddonWiseMappingMessage: null,

};

export default function reducer(state = initState, action) {

    switch (action.type) {

        case actions.OPEN_UPDATE_ADDON_MODAL:
            return {
                ...state,
                openAddonModal: true,
            };

        case actions.CLOSE_UPDATE_ADDON_MODAL:
            return {
                ...state,
                openAddonModal: false,
            };

        case actions.UPDATE_ADDON_PRICE_MAPPING_DATA_BY_DEALERID:
            return {
                ...state,
                updateAddonWiseMappingLoading: true,
                updateAddonWiseMappingError: null,
                updateAddonWiseMappingMessage: null,
            };
        case actions.UPDATE_ADDON_PRICE_MAPPING_DATA_BY_DEALERID_SUCCESS:
            return {
                ...state,
                updateAddonWiseMappingLoading: false,
                updateAddonWiseMappingError: null,
                updateAddonWiseMappingMessage: action.payload.message,
                openAddonModal: false,
            };
        case actions.UPDATE_ADDON_PRICE_MAPPING_DATA_BY_DEALERID_FAILED:
            return {
                ...state,
                updateAddonWiseMappingLoading: false,
                updateAddonWiseMappingError: action.payload.error,
                updateAddonWiseMappingMessage: null,
                openAddonModal: false,
            };

        case actions.GET_ADDON_WISE_MAPPING:
            return {
                ...state,
                addonWiseMappingLoading: true,
                addonWiseMappingError: null,
                addonWiseMappingMessage: null,
            };

        case actions.GET_ADDON_WISE_MAPPING_SUCCESS:
            return {
                ...state,
                addonWiseMappingLoading: false,
                addonWiseMappingError: null,
                addonWiseMappingMessage: null,
                addonWiseMappingList: action.payload.data,
            };

        case actions.GET_ADDON_WISE_MAPPING_FAILED:
            return {
                ...state,
                addonWiseMappingLoading: false,
                addonWiseMappingError: action.payload.error,
                addonWiseMappingMessage: null,
            };
        case actions.GET_ALL_ADDON_PRICE_MAPPING_DATA:
            return {
                ...state,
                loading: true,
                addonPriceMappingError: null,
                addonPriceMappingSuccess: null,
            };

        case actions.GET_ALL_ADDON_PRICE_MAPPING_DATA_SUCCESS:
            return {
                ...state,
                loading: false,
                addonPriceMappingError: null,
                addonPriceMappingSuccess: null,
                addonPriceMappingData: action.payload.data,
            };

        case actions.GET_ALL_ADDON_PRICE_MAPPING_DATA_FAILED:
            return {
                ...state,
                loading: false,
                addonPriceMappingError: action.payload.error,
                addonPriceMappingSuccess: null,
            };
        case actions.UPDATE_ADDON_PRICE_MAPPING_DATA:
            return {
                ...state,
                loading: true,
                buttonLoading: true,
                addonPriceMappingError: null,
                addonPriceMappingSuccess: null,
            };

        case actions.UPDATE_ADDON_PRICE_MAPPING_DATA_SUCCESS:
            return {
                ...state,
                loading: false,
                buttonLoading: false,
                addonPriceMappingError: null,
                addonPriceMappingSuccess: action.message,
                addonPriceMappingData: action.data,
            };

        case actions.UPDATE_ADDON_PRICE_MAPPING_DATA_FAILED:
            return {
                ...state,
                loading: false,
                buttonLoading: false,
                addonPriceMappingError: action.serror,
                addonPriceMappingSuccess: null,
            };
        case actions.RESET_ADDON_PRICE_MAPPING_MESSAGES:
            return {
                ...state,
                loading: false,
                buttonLoading: false,
                addonPriceMappingError: null,
                addonPriceMappingSuccess: null,
                updateAddonWiseMappingError: null,
                updateAddonWiseMappingMessage: null,
            };
        default:
            return state;
    }
}